import { useState } from 'react';

interface MutationConfig {
	onSucces?: (reponse: any) => void;
	onError?: (error: Error) => void,
	keepData?: boolean
}

interface IMutationHook {
	data: Record<string, any>
	error: Error
	isLoading: boolean
	mutate: MutationFn
}

type MutationFn = (data: Record<string, any>) => Promise<any>

export const useMutation = (mutateFunction: MutationFn, config?: MutationConfig): IMutationHook => {
	const { onSucces, onError, keepData = true } = config || {};
	const [data, setData] = useState(null);
	const [error, setError] = useState(null);
	const [isLoading, setIsLoading] = useState(false);


	const mutate = async (payload) => {
		try {
			if (!keepData) {
				setData(null);
			}

			setIsLoading(true);
			setError(null);

			const response = await mutateFunction(payload);
			setData(response);
			setIsLoading(false);

			if (onSucces) {
				onSucces(response);
			}
		} catch (err) {
			setIsLoading(false);
			setError(err);

			if (onError) {
				onError(err as Error);
			}

		}
	};

	return {
		data,
		error,
		isLoading,
		mutate
	};
};